/**
 * The waitlist, posted to our own API instead of the host's form handler.
 *
 * Two things changed in the move off Netlify Forms.
 *
 * The form no longer asks where someone is up to, or whether they are the
 * applicant or the sponsor. Those are their individual circumstances, and
 * collecting them — then letting anything downstream vary by them — is how a
 * waitlist turns into advice by conduct before the licence lands. Name and
 * email only.
 *
 * And consent is now recorded with the exact wording shown on screen. The API
 * stores the wording version alongside the address, so what someone agreed to
 * is reconstructable rather than inferred.
 */
const CONSENT_VERSION = "subscribe-v1";

const form = document.getElementById("waitlist-form") as HTMLFormElement | null;
const statusLine = document.getElementById("waitlist-status");
const button = document.getElementById("waitlist-submit") as HTMLButtonElement | null;

if (form && statusLine && button) {
  form.addEventListener("submit", (event) => {
    event.preventDefault();

    const data = new FormData(form);
    // Honeypot: a real person never fills a field they cannot see. Answer as
    // though it worked, so a bot learns nothing from the difference.
    if ((data.get("company") ?? "") !== "") {
      form.hidden = true;
      statusLine.textContent = "Thanks — you're on the list.";
      return;
    }

    const email = String(data.get("email") ?? "").trim();
    const firstName = String(data.get("first_name") ?? "").trim();
    if (email === "") return;

    button.disabled = true;
    statusLine.textContent = "Adding you…";

    void fetch("/api/subscribe", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        email,
        first_name: firstName === "" ? null : firstName,
        consent: { marketing: true, wording_version: CONSENT_VERSION },
      }),
    })
      .then((r) => {
        if (r.status === 429) {
          button.disabled = false;
          statusLine.textContent = "That's a lot of tries at once. Give it a minute and go again.";
          return;
        }
        if (!r.ok) throw new Error("failed");
        form.hidden = true;
        statusLine.textContent = "Thanks — you're on the list. We'll email you when there's something worth telling you.";
      })
      .catch(() => {
        button.disabled = false;
        statusLine.textContent =
          "That didn't go through. Try again, or email hello@getverity.co.uk and we'll add you by hand.";
      });
  });
}
